import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import jump from 'jump.js';

import { media } from 'legacyComponents/styled/styleUtils';
import {
  Div,
  SubPageStatsWrapper,
  SubPageStatName,
  Label,
} from 'legacyComponents/styled/lib';
import { withConditional } from 'legacyComponents/hoc/conditional';

import { conf } from 'apps/repository/config.yaml';

import { withNamespaces, Trans } from 'react-i18next';

const OpSection = withConditional(Div);

@withNamespaces()
@observer
export class ContributionPageStats extends React.Component {
  render() {
    const { contribution } = this.props;
    const { operations } = contribution;

    const addOps = operations.filter(op => op.opType === 'ADD');
    const updateOps = operations.filter(op => op.opType === 'UPDATE');
    const renameOps = operations.filter(op => op.opType === 'RENAME');
    const removeOps = operations.filter(op => op.opType === 'REMOVE');

    const sections = {
      Added: addOps,
      Updated: updateOps,
      Renamed: renameOps,
      Removed: removeOps,
    };

    return (
      <SubPageStatsWrapper width='28%'>
        {Object.entries(sections).map(([section, ops]) => (
          <OpSection
            condition={ops.length > 0}
            position='relative'
            key={section}
            margin='0px 0px 20px 0px'
          >
            <SubPageStatName first>
              <Trans>{section} Files</Trans> <Count>({ops.length})</Count>
            </SubPageStatName>
            {ops.map(op => (
              <ListLabel
                key={op.id}
                backgroundColor={conf.operationColors[op.opType]}
                onPointerDown={() => {
                  jump(`#${op.domId}`, { offset: -70 });
                }}
                block
              >
                {op.path}
              </ListLabel>
            ))}
          </OpSection>
        ))}
      </SubPageStatsWrapper>
    );
  }
}

const Count = styled.span`
  color: ${props => props.theme.color.wfGrey500};
`;

const ListLabel = styled(Label)`
  display: table;
  margin-bottom: 10px;
  margin-left: 20px;
  cursor: pointer;
  ${media.m`
    display: ${props =>
      props.block ? 'inline-block' : props.fixed ? 'inline-block' : 'none'};
    margin-top: 0px;
  `};
`;

ContributionPageStats.propTypes = {
  contribution: PropTypes.object,
};
